<template>
    <div>
        <rkm-area
            title="Gestante"
            type="fieldset"
        >

            <rkm-row>

                <rkm-col cols="2">
                    <rkm-form-date-picker
                            label="DUM"
                            :max-date="form.dataAtual"
                            :min-date="minDateDum"
                            v-model="model.dataUltimaMenstruacao"
                            :validations="validations.dum"
                            right
                        />
                    </rkm-col>

                <rkm-col cols="4">

                    <rkm-form-group
                        label-for="Idade gestacional"
                        label="Idade gestacional"
                        class="mb-0"
                    >
                        <rkm-row>
                            <rkm-col cols="6">
                                <rkm-form-input
                                    append="Semanas"
                                    name="Semanas"
                                    v-model="model.idadeGestacionalSemanas"
                                    :validations="validations.semanas"
                                    number
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <rkm-form-input
                                    append="Dias"
                                    name="Dias"
                                    v-model="model.idadeGestacionalDias"
                                    :validations="validations.dias"
                                    number
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-form-group>
                </rkm-col>

                <rkm-col>
                    <rkm-form-date-picker
                        label="DPP"
                        v-model="model.dataPossivelParto"
                        disabled
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-radio-group
                        v-model="model.gravidezPlanejada"
                        label="Gravidez planejada"
                    >
                        <rkm-form-radio :value="true">Sim</rkm-form-radio>
                        <rkm-form-radio :value="false">Não</rkm-form-radio>
                    </rkm-form-radio-group>
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        label="Gestações prévias"
                        v-model="model.gestacaoPrevia"
                        :validations="validations.gestacoesPrevias"
                        number
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        label="Partos"
                        v-model="model.parto"
                        :validations="validations.partos"
                        number
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </div>
</template>

<script>

//Moment
import moment from 'moment'

export default {
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    computed: {
        validations() {

            return {
                outrasCondicoesSaude: { max: 5000 }
            }
        },
        minDateDum() {

            return moment(this.model.cidadao.dataNascimento, 'YYYY-MM-DD').format('DD/MM/YYYY');
        },
    },
    methods: {
        calcularIdade() {
            const dataAtual = moment(this.form.dataAtual);
            const idade = dataAtual.diff(this.model.dataNascimento, 'years');

            if (!this.model.gestante && idade < 9
                || !this.model.gestante &&  idade > 60) {

                this.model.gestante = null
                this.resetMaternidadeReferencia()

                return true;
            }

            return false;
        },
        getGestacao() {

            const dataAtual = moment(this.form.dataAtual, 'DD/MM/YYYY');
            const diferenca = dataAtual - moment(this.model.dataUltimaMenstruacao, 'YYYY-MM-DD');
            const diasTotais = Math.floor(diferenca / (1000 * 60 * 60 * 24));

            const semanasCompletas = Math.floor(diasTotais / 7);
            const diasRestantes = diasTotais % 7;

            this.model.idadeGestacionalSemanas = semanasCompletas
            this.model.idadeGestacionalDias = diasRestantes
        },
        getDataProvavelParto() {

            const dataUltimaMenstruacaoMoment = moment(this.model.dataUltimaMenstruacao, 'YYYY-MM-DD');
            const dataProvavelPartoMoment = moment(dataUltimaMenstruacaoMoment).add(294, 'days');

            this.model.dataPossivelParto = dataProvavelPartoMoment.format('YYYY-MM-DD');
        },
        resetGestante() {

            this.model.idadeGestacionalSemanas = null
            this.model.idadeGestacionalDias = null
            this.model.gravidezPlanejada = null
            this.model.dataPossivelParto = null
            this.model.gestacaoPrevia = null
            this.model.parto = null
        },
    },
    mounted() {

        if(this.model.dataUltimaMenstruacao){

            this.getGestacao()
            this.getDataProvavelParto()
        }
    },
    watch: {
        'model.dataUltimaMenstruacao': function (dum) {

            if (dum) {

                this.getGestacao()
                this.getDataProvavelParto()
            } else{
                this.resetGestante()
            }
        },
    }
}
</script>